import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";

export class Dataset extends Resource {
    public override type = 'datasets';  

    @prop()
    @required()
    public name!: string;   

    @prop()
    @required()
    public sql!: string;            
        
    @prop()
    @required()
    public active: boolean = true;

    @prop()
    public lastSnapshotDate!: string;

    @prop()
    public lastSnapshotDuration!: string;

    @prop()
    public lastSnapshotSuccess!: boolean;

    @prop()
    public lastSnapshotError!: string;

}